import { createContext, useState } from 'react';

export const LdsHeaderContext = createContext();

export function LdsHeaderProvider({
  currentRoute,
  children,
}) {
  /* Store the open dropdown id so we can apply specific stylings and functionality
    like closing other dropdowns when another is hover opened.
    This is a little different between dropdowns, flyouts, and mobile menus so we
    track each individually.
  */
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openFlyoutId, setOpenFlyoutId] = useState(null);
  const [openMobileMenuId, setOpenMobileMenuId] = useState(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <LdsHeaderContext.Provider
      value={{
        currentRoute,
        openDropdownId,
        setOpenDropdownId,
        openFlyoutId,
        setOpenFlyoutId,
        openMobileMenuId,
        setOpenMobileMenuId,
        isSearchOpen,
        setIsSearchOpen,
      }}
    >
      {children}
    </LdsHeaderContext.Provider>
  );
}
